import { Component, OnDestroy,OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { NavButton } from "../../shared/components/navigation/next-button.component";
import { appConfig, clientConfig } from "../../shared/constant/app.constant";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { FileHelper } from "../../shared/helpers/file.helper";
import { addLabelToReturnOrder } from "../../store/actions/order.actions";
import { SpinnerService } from "../../shared/services/spinner.service";
import { DeliveryOptionsService, ShippingType } from "../../shared/services/delivery-options.service";
import { Shipment } from "../../shared/models/shipmentResponse.model";
import { TranslationDataService } from "../../shared/services/translation-data.service";
import { ThemeService } from "../../shared/theme/theme.service";
import { EmailNotificationRequest } from "ClientApp/src/app/shared/services/messageBus/email-notification-request";
import { MessageBusService } from "ClientApp/src/app/shared/services/messageBus/message-bus.service";
import { SENDER_EMAIL, NOTIFICATION_SUBJECT } from "../../shared/constant/notification.constants"

@Component({
  selector: "return-created",
  templateUrl: "./return-created.component.html",
  styleUrls: ["./return-created.component.scss"],
})
export class ReturnCreatedComponent implements OnInit,OnDestroy{
  show = false;
  header = "shippingDetailsHeader";
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };
  banner_src:any = clientConfig.BANNER_JPG;
  screenNav: NavButton = {
    buttonText: "Return created",
  };
  returnOrder$: Observable<any>;
  returnOrderResponse: any;
  showError: any = {
    show: false,
  };
  order: any;
  deliveryOption: any;
  type: any;
  shippingOption = clientConfig.SHIPPING_OPTIONS;
  showDownloadButton = false;
  shipment: Shipment;
  subscription:any;
  showInstructionFour: boolean = false;
  showInstructionFive: boolean = false;
  isEmailNotificationEnabled: boolean = clientConfig.EMAIL_NOTIFICATION_ENABLED;
  defaultExternalTemplateIds: string[] = clientConfig.EXTERNAL_TEMPLATEIDS;

  param = { emailaddress: "" };
  constructor(
    private appFlowService: AppFlowService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private spinnerService: SpinnerService,
    private translateService: TranslateService,
    private deliveryOptionsService: DeliveryOptionsService,
    private themeService: ThemeService,
    public translationDataService: TranslationDataService,
    private messageBusService: MessageBusService,
    private translate: TranslateService
  ) {
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        this.order = ro;
        this.deliveryOption = ro.deliveryOption.type;
      });

    this.type = deliveryOptionsService.getTypeByMode(this.deliveryOption);

    this.param.emailaddress = this.order.orderAddress.contactInfo.email;

    if (clientConfig.APPFLOW === "formPostPrePopulatedOrder" || clientConfig.APPFLOW === "loginAppFlowPrePopulated") {
      this.appFlowService.activeStepId = this.appFlowService.getActiveId("labelprint");
    } else {
      this.appFlowService.activeStepId = this.screenNav.number;
    }

    spinnerService.show();
    this.returnOrder$ = this.store.pipe(select("returnOrder"));

    if (!!this.deliveryOption) {
      this.showDownloadButton = deliveryOptionsService.getShippingOption(this.deliveryOption).downloadReturnLabel;
    }

    this.shipment = this.activatedRoute.snapshot.data.returnOrderResponse;
    this.showShippingInstructions();

    this.returnOrderResponse = this.shipment.labelDataArray;

    if (this.showDownloadButton) {
      this.setDownloadData();
    }

    if(this.isEmailNotificationEnabled) this.sendEmailNotification();

    spinnerService.hide();
  }

  ngOnInit(){
    if (clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true") {
      this.subscription=this.themeService.banner$.subscribe(banner => {
          this.banner_src = banner.data
      });
    }
    this.translateService.onLangChange.subscribe(event => {
      this.showShippingInstructions();
    });
  }
  ngOnDestroy(){
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setDownloadData() {
    if (this.returnOrderResponse && this.returnOrderResponse.length) {
      this.store.dispatch(
        addLabelToReturnOrder({
          payload: {
            documents: this.returnOrderResponse,
            isComplete: true,
          },
        })
      );
    } else {
      this.show = true;
    }
  }

  isCollectionType(modeOfTransport) {
    return this.deliveryOptionsService.getTypeByMode(modeOfTransport) === ShippingType.Collection;
  }

  hasInstruction(key, value) {
    try {
      if (value.length > 0) {
        if (key !== value) {
          return true;
        }
      }
    } catch (Exception) {}
    return false;
  }

  downloadLabel() {
    this.spinnerService.show();
    this.returnOrderResponse.forEach((label) => {
      if (label.externalParcelIdentifier && label.data) {
        FileHelper.Base64ToFile(
          `${label.externalParcelIdentifier}.${clientConfig.LABEL_FORMAT}`,
          label.data,
          clientConfig.LABEL_FORMAT
        );
        this.spinnerService.hide();
      } else {
        this.showError = {
          show: true,
          message: "downloadFail",
        };
        this.spinnerService.hide();
      }
    });
  }

  handleImageError(event:any)
  {
    if (event.target.dataset.errorHandled) {
      return;
    }
      // Handle the error, set a fallback image
      if (clientConfig.MERCHANTNAME.toLowerCase().includes("sony"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sonyBanner.jpg`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("schneider"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/schneiderBanner.jpg`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("starlink"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/starlinkBanner.jpg`;
      else
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sonyBanner.jpg`;

        event.target.dataset.errorHandled = 'true';
  }

  showShippingInstructions() {
    const defaultInstructionFour = `shippingOptions.${this.type}.defaultShippingInstructions.shippingDetailedInstructionFourHeader`;
    this.translateService
      .get(defaultInstructionFour)
      .subscribe((defaultResponse) => {
        const carrierResponse = this.translationDataService.getShippingInstructions('shippingDetailedInstructionFourHeader', this.type, this.deliveryOption);

        this.showInstructionFour = this.hasInstruction(
          defaultInstructionFour,
          carrierResponse || defaultResponse
        );
      });

    const defaultInstructionFive = `shippingOptions.${this.type}.defaultShippingInstructions.shippingDetailedInstructionFiveHeader`;
    this.translateService
      .get(defaultInstructionFive)
      .subscribe((defaultResponse) => {
        const carrierResponse = this.translationDataService.getShippingInstructions('shippingDetailedInstructionFiveHeader', this.type, this.deliveryOption);

        this.showInstructionFive = this.hasInstruction(
          defaultInstructionFive,
          carrierResponse || defaultResponse
        );
      });
  }

  sendEmailNotification() {
    const templateId = this.resolveExternalTemplateId();
    if (!templateId) return this.logWarning("Notification not sent — no matching externalTemplateId found.");

    const request = this.mapNotificationRequest(templateId);
    if (!request) return this.logWarning("Notification request could not be created.");

    this.messageBusService.sendEmailNotification(request).subscribe({
      next: () => console.log('Notification sent!'),
      error: (err) => console.error('Error sending notification:', err)
    });
  }

  resolveExternalTemplateId(): string | null {
    const merchantTemplates = this.defaultExternalTemplateIds || {};
    const language = (this.translate.currentLang || '').toLowerCase();
    const shippingTemplates = this.getShippingOptionTemplates();

    const templates: Record<string, string> =
      (shippingTemplates && Object.keys(shippingTemplates).length > 0)
        ? shippingTemplates
        : merchantTemplates;

    if (!templates || Object.keys(templates).length === 0) {
      this.logWarning("No notification templates found in shipping option or merchant config.");
      return null;
    }

    const matchedKey = Object.keys(templates).find(key => key.toLowerCase().includes(language));
    if (matchedKey)
      templates[matchedKey];

    const defaultKey = Object.keys(templates).find(key => key.toLowerCase().includes('default'));
    if (defaultKey)
      return templates[defaultKey];

    if (templates !== merchantTemplates) {
      const merchantDefaultKey = Object.keys(merchantTemplates).find(key => key.toLowerCase().includes('default'));

      if (merchantDefaultKey)
        return merchantTemplates[merchantDefaultKey];
    }

    this.logWarning(`No language-specific or default template found. Please configure a template containing '${language}' or 'default'.`);

    return null;
  }

  getShippingOptionTemplates(): Record<string, string> | null {
    if (!this.shippingOption || !this.deliveryOption) return null;

    const matchedOption =
      (this.shippingOption.dropOffStore?.find(x => x.modeOfTransport === this.deliveryOption)) ||
      (this.shippingOption.dropOffServiceCenter?.find(x => x.modeOfTransport === this.deliveryOption)) ||
      (this.shippingOption.collection?.find(x => x.modeOfTransport === this.deliveryOption));

    return matchedOption?.externalTemplateIds || null;
  }

  mapNotificationRequest(templateId: string): EmailNotificationRequest | null {
    const email = this.order?.orderAddress?.contactInfo?.email;
    if (!email) return this.logError("Receiver email not available.");

    const labels = this.mapLabelsForNotificationTemplates();
    if (!labels) return null;

    return {
      receiverEmail: email,
      senderEmail: SENDER_EMAIL,
      sendGridTemplateCode: templateId,
      subject: NOTIFICATION_SUBJECT,
      body: labels
    };
  }

  mapLabelsForNotificationTemplates(): Record<string, string> | null {
    const validLabels = this.returnOrderResponse
      ?.filter(x => x.externalParcelIdentifier && x.data) || [];

    if (!validLabels.length) return this.logError("No valid labels found.");

    const labelFormat =
      this.order?.deliveryOption?.labelFormat?.toLowerCase() ||
      clientConfig.LABEL_FORMAT;

    const labelMap: Record<string, string> = {};

    validLabels.forEach(x => {
      const fileName = `${x.externalParcelIdentifier}.${labelFormat}`;
      labelMap[fileName] = x.data;
    });

    return labelMap;
  }

  logInfo(msg: string) { console.log(`INFO: ${msg}`); }
  logWarning(msg: string) { console.warn(`WARN: ${msg}`); return null; }
  logError(msg: string, err?: any) { console.error(`ERROR: ${msg}`, err || ""); return null; }
  
}
